module.exports = __webpack_public_path__ + "img/Group 26847@2x.67d8072a.png";